export enum  TextInfoConsent{

    ACCEPTED = 'ACCEPTED' ,

    NOT_ACCEPTED = 'NOT_ACCEPTED'

}